import esLocale from 'react-intl/locale-data/es';
import enLocale from 'react-intl/locale-data/en';
import deLocale from 'react-intl/locale-data/de';
import ruLocale from 'react-intl/locale-data/ru';
import zhLocale from 'react-intl/locale-data/zh';
import csLocale from 'react-intl/locale-data/cs';
import frLocale from 'react-intl/locale-data/fr';
import hrLocale from 'react-intl/locale-data/hr';
import itLocale from 'react-intl/locale-data/it';
import huLocale from 'react-intl/locale-data/hu';
import nlLocale from 'react-intl/locale-data/nl';
import ptLocale from 'react-intl/locale-data/pt';
import slLocale from 'react-intl/locale-data/sl';
import trLocale from 'react-intl/locale-data/tr';
import jaLocale from 'react-intl/locale-data/ja';
import thLocale from 'react-intl/locale-data/th';
import heLocale from 'react-intl/locale-data/he';

const locales = [
    ...esLocale,
    ...enLocale,
    ...deLocale,
    ...ruLocale,
    ...zhLocale,
    ...csLocale,
    ...frLocale,
    ...hrLocale,
    ...itLocale,
    ...huLocale,
    ...nlLocale,
    ...ptLocale,
    ...slLocale,
    ...trLocale,
    ...jaLocale,
    ...thLocale,
    ...heLocale,
];

export default locales;
